/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTickets } from '../fn/tickets/get-tickets';
import { GetTickets$Params } from '../fn/tickets/get-tickets';
import { GetTicketsResult } from '../models/get-tickets-result';
import { postGeneratePdf } from '../fn/tickets/post-generate-pdf';
import { PostGeneratePdf$Params } from '../fn/tickets/post-generate-pdf';
import { postGeneratePdfBatch } from '../fn/tickets/post-generate-pdf-batch';
import { PostGeneratePdfBatch$Params } from '../fn/tickets/post-generate-pdf-batch';

@Injectable({ providedIn: 'root' })
export class ApiTicketsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postTicketsGeneratePdf()` */
  static readonly PostTicketsGeneratePdfPath = '/Tickets/generate-pdf';

  /**
   * post-tickets-generate-pdf.
   *
   * Summary<br>Generate ticket pdf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postGeneratePdf()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postGeneratePdf$Response(params?: PostGeneratePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return postGeneratePdf(this.http, this.rootUrl, params, context);
  }

  /**
   * post-tickets-generate-pdf.
   *
   * Summary<br>Generate ticket pdf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postGeneratePdf$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postGeneratePdf(params?: PostGeneratePdf$Params, context?: HttpContext): Observable<any> {
    return this.postGeneratePdf$Response(params, context).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `getTickets()` */
  static readonly GetTicketsPath = '/Tickets';

  /**
   * get-tickets.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickets$Response(params?: GetTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTicketsResult>> {
    return getTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * get-tickets.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickets(params?: GetTickets$Params, context?: HttpContext): Observable<GetTicketsResult> {
    return this.getTickets$Response(params, context).pipe(map((r: StrictHttpResponse<GetTicketsResult>): GetTicketsResult => r.body));
  }

  /** Path part for operation `postTicketsGeneratePdfBatch()` */
  static readonly PostTicketsGeneratePdfBatchPath = '/Tickets/generate-pdf-batch';

  /**
   * post-tickets-generate-pdf-batch.
   *
   * Summary<br>Generate tickets for a specified period in a single pdf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postGeneratePdfBatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postGeneratePdfBatch$Response(params?: PostGeneratePdfBatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return postGeneratePdfBatch(this.http, this.rootUrl, params, context);
  }

  /**
   * post-tickets-generate-pdf-batch.
   *
   * Summary<br>Generate tickets for a specified period in a single pdf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postGeneratePdfBatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postGeneratePdfBatch(params?: PostGeneratePdfBatch$Params, context?: HttpContext): Observable<any> {
    return this.postGeneratePdfBatch$Response(params, context).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }
}
